import { render, staticRenderFns } from "./ShareOverdue.vue?vue&type=template&id=0815acd7&scoped=true&"
import script from "./ShareOverdue.vue?vue&type=script&lang=js&"
export * from "./ShareOverdue.vue?vue&type=script&lang=js&"
import style0 from "./ShareOverdue.vue?vue&type=style&index=0&id=0815acd7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0815acd7",
  null
  
)

export default component.exports